import { Component, HostListener, OnInit} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { Viewport, NxViewportService } from './nx-viewport.service';

@Component({
  selector: 'nx-viewport',
  template: `
    <div class="wrapper">
      <ng-content></ng-content>
    <div>
  `,
  styles: [
    `.wrapper { display: flex; flex-direction: column;margin: 0; width: 100%; min-height:100%;}`
  ]
})
export class NxViewportComponent implements OnInit {
  
  private mediaSubscription: Subscription;
  private activeMediaQuery: any;
  
  viewport: Viewport = {
    name: 'xs',
    width: 0,
    height: 0,
    orientation: 'none',
    class: '',
    position: 0
  }

  constructor(
    private mediaObserver: MediaObserver,
    private _viewport: NxViewportService
    ) {
      this.onResize();
      this.onWindowScroll();

    }

    
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event?:any) {    
    this.viewport.position = window.scrollY;
    this.viewportMedia(); 
  }

  @HostListener('window:resize', ['$event']) 
  onResize(event?: any) {
    this.viewport.width = window.innerWidth;
    this.viewport.height = window.innerHeight;
    if (window.innerHeight > window.innerWidth) {
      // this.viewport.height = window.innerHeight * 9 / 16;
      this.viewport.orientation = 'portrait';
      // console.log('activeMediaQuery', this.viewport.orientation);
      this.viewport.class = this.viewport.orientation + '-' + this.viewport.name;
    } else {
      this.viewport.orientation = 'landscape';
      // console.log('activeMediaQuery', this.viewport.orientation);
      this.viewport.class = this.viewport.orientation + '-' + this.viewport.name;
    }
    this.viewportMedia(); 
  }


  ngOnInit(): void {
    this.mediaSubscription = this.mediaObserver
      .asObservable()
      .subscribe((change) => {
        change.forEach((item) => {
          this.activeMediaQuery = item
            ? `'${item.mqAlias}' = (${item.mediaQuery})`
            : '';
            
          if (item.mqAlias === 'xs') {
            this.viewport.name = item.mqAlias;
            this.viewport.class = this.viewport.orientation + '-' + item.mqAlias;
            this.viewportMedia(); 
          }
          if (item.mqAlias === 'sm') {
            this.viewport.name = item.mqAlias;
            this.viewport.class = this.viewport.orientation + '-' + item.mqAlias;
            this.viewportMedia(); 
          }
          if (item.mqAlias === 'md') {
            this.viewport.name = item.mqAlias;
            this.viewport.class = this.viewport.orientation + '-' + item.mqAlias;
            this.viewportMedia(); 
          }
          if (item.mqAlias === 'lg') {
            this.viewport.name = item.mqAlias;
            this.viewport.class = this.viewport.orientation + '-' + item.mqAlias;
            this.viewportMedia(); 
          }
          if (item.mqAlias === 'xl') {
            this.viewport.name = item.mqAlias;
            this.viewport.class = this.viewport.orientation + '-' + item.mqAlias;
            this.viewportMedia(); 
          }
          // console.log('activeMediaQuery', this.activeMediaQuery);
        });
      });
    // this.onResize();    
  }

  viewportMedia() {
    // console.log('nx-viewport', this.viewport.position);
    this._viewport.update(this.viewport);
  }


  ngOnDestroy(): void {
    this.mediaSubscription.unsubscribe();
  }

}